import {Typography} from '@mui/material'
import {Controller} from 'react-hook-form'
import {DocumentUploadField, WorkExperienceList} from '../../../../components'
import {caregiverDocumentCategories} from '../../../../utils/helpers'

export default ({form}) => {
    // Documents and work experiences stay in the step's form so they survive
    // moving between steps; the wizard saves them once the caregiver exists.
    const renderDocuments = (name, label, categories) => (
        <Controller
            name={name}
            control={form.control}
            defaultValue={[]}
            render={({field}) => (
                <DocumentUploadField
                    label={label}
                    categories={categories}
                    value={field.value}
                    onChange={field.onChange}
                    simulateProgress={false}
                />
            )}
        />
    )

    return (
        <>
            <Typography variant="overline" color="text.secondary">
                BACKGROUNDS
            </Typography>
            <br />
            <br />
            {renderDocuments('governmentIds', 'Government ID', caregiverDocumentCategories.governmentId)}
            <br />
            {renderDocuments('criminalRecords', 'Criminal Record Check Report', caregiverDocumentCategories.criminalRecord)}
            <br />
            <br />
            <Controller
                name="workExperiences"
                control={form.control}
                defaultValue={[]}
                render={({field}) => <WorkExperienceList value={field.value} onChange={field.onChange} />}
            />
            <br />
            <br />
            <Typography variant="overline" color="text.secondary">
                PROFESSIONAL CREDENTIALS
            </Typography>
            <br />
            {renderDocuments('licenses', 'Licenses or Certifications', caregiverDocumentCategories.licenses)}
        </>
    )
}
